import { advertiserBlockList } from "actions/publisher";
import React, { useRef, useState } from "react";
import {
  Card,
  Container,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  UncontrolledCollapse,
  Badge,
  UncontrolledTooltip,
} from "reactstrap";
import NotificationAlert from "react-notification-alert";
import { getAdvertiserBlockList } from "actions/publisher";
import { downloadAdvertiserBlockList } from "actions/publisher";
import { downloadAdsTxt } from "actions/publisher";
import { getAdvertizeListFile } from "actions/publisher";
import { getAdsFile } from "actions/publisher";
import { downloadAdvertiseTxt } from "actions/publisher";
import ReactBsTable from "components/Tables/ReactBsTable";
import { dataTable } from "variables/general";
import { DataTableData } from "variables/general";
import { getAdvertiserBlockListLogs } from "actions/publisher";
import { getAdvertiserLogsList } from "actions/publisher";
import { getAdsLogsList } from "actions/publisher";

const Actions = () => {
  const fileInputRef = useRef(null);
  const notificationAlertRef = useRef(null);
  const [csvDocument, setCsvDocument] = useState({
    blockList: {},
    advertizeDocument: {},
    adsDocument: {},
  });
  const [csvData, setCSVData] = useState({
    data: DataTableData, //[],
    AdvertiserBlockListLogs: { data: [], totalRecords: 0 },
    AdvertiserListLogs: { data: [], totalRecords: 0 },
    AdsListLogs: { data: [], totalRecords: 0 },
    totalRecords: 6,
  });
  const [showCsvPreview, setShowCsvPreview] = useState(false);
  const [csvPreviewModal, setCsvPreviewModal] = useState(false);
  const [pageNum, setPageNum] = useState(1);
  const [csvPreviewUrl, setCsvPreviewUrl] = useState("");

  const [open, setOpen] = useState("1");
  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };

  React.useEffect(() => {
    fetchBlockList();
  }, []);

  const fetchBlockList = async () => {
    try {
      const res = await getAdsFile();
      const advertizeRes = await getAdvertizeListFile();
      const blockListres = await getAdvertiserBlockList();
      const advertiseblockListLogs = await getAdvertiserBlockListLogs(0);
      const advertiseListLogs = await getAdvertiserLogsList(0);
      const adsLogsList = await getAdsLogsList(0);
      setCSVData((prev) => ({
        ...prev,
        AdvertiserBlockListLogs: {
          data: advertiseblockListLogs?.data?.AdvertiseBlocklistVersion,
          totalRecords: advertiseblockListLogs?.data.totalRecords,
        },
        AdvertiserListLogs: {
          data: advertiseListLogs?.data.AdvertiseListVersion,
          totalRecords: advertiseListLogs?.data.totalRecords,
        },
        AdsListLogs: {
          data: adsLogsList?.data.AdsTxtVersion,
          totalRecords: adsLogsList?.data.totalRecords,
        },
      }));
      setCsvDocument({
        ...csvDocument,
        adsDocument: res?.data,
        advertizeDocument: advertizeRes.data,
        blockList: blockListres.data,
      });
    } catch (err) {
      console.error(err);
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // ✅ Validate CSV
    if (!file.name.toLowerCase().endsWith(".csv")) {
      notify("danger", "Only CSV files are allowed");
      return;
    }

    const MAX_FILE_SIZE = 10 * 1024 * 1024;
    if (file.size > MAX_FILE_SIZE) {
      notify("danger", "File size should not exceed 10 MB");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("document", file); // must match backend key

      const res = await advertiserBlockList(formData);

      if (res?.code === 200) {
        notify("success", "Advertiser blocklist uploaded successfully");
        // Refresh the block list data
        const updatedRes = await getAdvertiserBlockList();
        setCsvDocument(updatedRes?.data);
      } else {
        notify("danger", res?.message || "Upload failed");
      }
    } catch (err) {
      notify("danger", "Something went wrong while uploading");
    }
    fetchBlockList();
  };

  const notify = (type, message) => {
    notificationAlertRef.current.notificationAlert({
      place: "tr",
      message: <div>{message}</div>,
      type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: 5,
    });
  };

  const handleFileUpload = () => {
    fileInputRef.current.click();
  };

  const openCsvPreviewModal = (fileUrl) => {
    setCsvPreviewUrl(fileUrl);
    setCsvPreviewModal(true);
  };

  const closeCsvPreviewModal = () => {
    setCsvPreviewModal(false);
    setCsvPreviewUrl("");
  };

  const getTrimmedFileName = (fileUrl, maxLength = 20) => {
    if (!fileUrl) return "";

    // Extract filename from URL
    const fileName = decodeURIComponent(fileUrl.split("/").pop());

    // Trim if too long
    if (fileName.length <= maxLength) return fileName;

    return `${fileName.slice(0, maxLength)}...`;
  };

  const columns = [
    {
      text: "Sr. No.",
      dataField: "srNo",
      // formatter: (_, __, i) => i + 1,
      formatter: (_, __, rowIndex) => (pageNum - 1) * 10 + rowIndex + 1,
    },
    // {
    //   dataField: "userName",
    //   text: "Uploaded By",
    //   formatter: (_, row) => (row?.userName != " " ? row?.userName : "-"),
    // },
    {
      text: "Document",
      dataField: "fileUrl",
      formatter: (_, row) =>
        row.fileUrl ? (
          <span
            className="text-info"
            onClick={() => openCsvPreviewModal(row.fileUrl)}
            style={{ cursor: "pointer" }}
            title={decodeURIComponent(row.fileUrl.split("/").pop())} // full name on hover
          >
            {getTrimmedFileName(row.fileUrl)}
          </span>
        ) : (
          "-"
        ),
    },
    {
      dataField: "version",
      text: "version",
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell) => (
        <Badge color={cell === "ACTIVE" ? "success" : "danger"}>{cell}</Badge>
      ),
    },
    {
      dataField: "createdAt",
      text: "Created On",
      formatter: (_, row) => (row?.createdAt != "" ? row?.createdAt : "-"),
    },
    {
      dataField: "updatedAt",
      text: "Updated On",
      formatter: (_, row) => (row?.updatedAt != "" ? row?.updatedAt : "-"),
    },
  ];

  const CardSection = ({
    header,
    paragraph,
    btntext,
    showTextArea = false,
    showuploadIcon = false,
    showDownloadIcon = false,
    downloadcsvbtnclick,
    showDownloadcsvbtn = false,
    downloadcsvbtntext,
    onClick,
    showViewButton = false,
    showDivider = false,
    rightContent, // 🔹 NEW: extra UI section
    collapseId, // ✅ NEW PROP
    tableHeading,
    tableDescription,
    data,
  }) => {
    const togglerId = `toggler-${collapseId}`;
    return (
      <Container fluid className="mt-2">
        <Card className="advertiser-card">
          <CardBody className="card-section-wrapper">
            <div className="card-left">
              <h4 className="advertiser-title">{header}</h4>

              <p className="advertiser-subtitle">{paragraph}</p>
              <div className="display-flex">
                <Button className="btn-gradient-primary" onClick={onClick}>
                  {showuploadIcon && <i className="fa fa-upload mr-2" />}
                  {showDownloadIcon && <i className="fa fa-download mr-2" />}
                  {btntext}
                </Button>
                {showDownloadcsvbtn && (
                  <Button
                    className="btn-gradient-primary"
                    onClick={downloadcsvbtnclick}
                  >
                    <i className="fa fa-download mr-2" />
                    {downloadcsvbtntext}
                  </Button>
                )}
              </div>
            </div>
            {/* {showTextArea && (
              <textarea
                className="ads-textarea"
                rows="5"
                disabled
                defaultValue={csvDocument.adsDocument.fileUrl}
              />
            )} */}
            {showDivider && <div className="vertical-divider" />}
            <div className="card-right">
              {rightContent}

              {showViewButton && (
                <Button color="info" outline className="mt-2">
                  Info
                </Button>
              )}
            </div>
          </CardBody>
          <div>
            <Button
              color="secondary"
              id={togglerId}
              size="sm"
              className="ml-4 mb-3"
            >
              View Logs
            </Button>

            <UncontrolledCollapse toggler={`#${togglerId}`}>
              <Container fluid>
                {/* <Card> */}
                <ReactBsTable
                  title={tableHeading}
                  description={tableDescription}
                  data={data.data}
                  columns={columns}
                  showAddbtn={false}
                  keyField="ID"
                  enablePagination={false}
                  // page={pageNum}
                  // sizePerPage={10}
                  totalRecords={data?.totalRecords}
                  // onPageChange={(p) => setPageNum(p)}
                />
                {/* </Card> */}
              </Container>
            </UncontrolledCollapse>
          </div>
        </Card>
      </Container>
    );
  };

  const downloadADSListCsv = async () => {
    try {
      const response = await downloadAdsTxt();

      // If response contains CSV data as text/string
      let csvData = "";

      // Extract CSV data from response
      if (typeof response === "string") {
        csvData = response;
      } else if (response?.data) {
        // If response is an object with data property
        if (typeof response.data === "string") {
          csvData = response.data;
        } else if (Array.isArray(response.data)) {
          // If data is an array, convert to CSV
          csvData = response.data.join("\n");
        } else {
          // If data is an object, try to stringify
          csvData = JSON.stringify(response.data);
        }
      } else if (response?.csv) {
        csvData = response.csv;
      }

      if (!csvData) {
        notify("danger", "No data received from server");
        return;
      }

      // Create a Blob from the CSV data
      const blob = new Blob([csvData], { type: "text/plain;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "ADS_list.txt";
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up
      window.URL.revokeObjectURL(url);

      notify("success", "Blocklist downloaded successfully");
    } catch (err) {
      console.error("Download failed", err);
      notify("danger", "Failed to download blocklist");
    }
  };

  const downloadlistCsv = async () => {
    try {
      const response = await downloadAdvertiseTxt();

      // If response contains CSV data as text/string
      let csvData = "";

      // Extract CSV data from response
      if (typeof response === "string") {
        csvData = response;
      } else if (response?.data) {
        // If response is an object with data property
        if (typeof response.data === "string") {
          csvData = response.data;
        } else if (Array.isArray(response.data)) {
          // If data is an array, convert to CSV
          csvData = response.data.join("\n");
        } else {
          // If data is an object, try to stringify
          csvData = JSON.stringify(response.data);
        }
      } else if (response?.csv) {
        csvData = response.csv;
      }

      if (!csvData) {
        notify("danger", "No data received from server");
        return;
      }

      // Create a Blob from the CSV data
      const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "advertiser_list.csv";
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up
      window.URL.revokeObjectURL(url);

      notify("success", "Blocklist downloaded successfully");
    } catch (err) {
      console.error("Download failed", err);
      notify("danger", "Failed to download blocklist");
    }
  };

  const downloadBlocklistCsv = async () => {
    try {
      const response = await downloadAdvertiserBlockList(0);

      // If response contains CSV data as text/string
      let csvData = "";

      // Extract CSV data from response
      if (typeof response === "string") {
        csvData = response;
      } else if (response?.data) {
        // If response is an object with data property
        if (typeof response.data === "string") {
          csvData = response.data;
        } else if (Array.isArray(response.data)) {
          // If data is an array, convert to CSV
          csvData = response.data.join("\n");
        } else {
          // If data is an object, try to stringify
          csvData = JSON.stringify(response.data);
        }
      } else if (response?.csv) {
        csvData = response.csv;
      }

      if (!csvData) {
        notify("danger", "No data received from server");
        return;
      }

      // Create a Blob from the CSV data
      const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "advertiser_block_list.csv";
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up
      window.URL.revokeObjectURL(url);

      notify("success", "Blocklist downloaded successfully");
    } catch (err) {
      console.error("Download failed", err);
      notify("danger", "Failed to download blocklist");
    }
  };

  return (
    <>
      <div className="rna-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>

      {/* CSV Preview Modal */}
      <Modal
        isOpen={csvPreviewModal}
        toggle={closeCsvPreviewModal}
        className="modal-md"
        style={{ maxWidth: "70%" }}
      >
        <ModalHeader toggle={closeCsvPreviewModal}>
          {csvPreviewUrl === csvDocument?.blockList?.fileUrl
            ? "Advertiser Block List Preview"
            : csvPreviewUrl === csvDocument?.advertizeDocument?.fileUrl
              ? "Advertiser List Preview"
              : csvPreviewUrl === csvDocument?.adsDocument?.fileUrl
                ? "ADS List Preview"
                : "Document Preview"}
          <Button
            color="info"
            size="sm"
            className="ml-2"
            onClick={() => {
              if (csvPreviewUrl === csvDocument?.blockList?.fileUrl) {
                downloadBlocklistCsv();
              } else if (
                csvPreviewUrl === csvDocument?.advertizeDocument?.fileUrl
              ) {
                downloadlistCsv();
              } else if (csvPreviewUrl === csvDocument?.adsDocument?.fileUrl) {
                downloadADSListCsv();
              }
            }}
          >
            <i className="fa fa-download mr-1" /> Download
          </Button>
        </ModalHeader>
        <ModalBody style={{ height: "70vh", padding: 0 }}>
          {csvPreviewUrl ? (
            <iframe
              src={csvPreviewUrl}
              title="CSV Preview"
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
            />
          ) : (
            <div className="text-center p-5">
              <p>No document available for preview</p>
            </div>
          )}
        </ModalBody>
      </Modal>

      <div className="action-form-container mt--6">
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          className="action_documnet"
          accept=".csv"
        />

        <CardSection
        
          header={"Advertiser Block List"}
          // paragraph={
          //   csvDocument?.blockList?.fileUrl ? (
          //     <div className="d-flex align-items-center">
          //       {/* <span
          //         className="pointer text-primary text-decoration-underline"
          //         onClick={() => openCsvPreviewModal(csvDocument?.blockList?.fileUrl)}
          //         style={{cursor:"pointer"}}
          //       >
          //         View Advertiser Block List
          //       </span>
          //       <i
          //         className="fa fa-download ml-2 text-info pointer"
          //         title="Download"
          //         onClick={(e) => {
          //           e.stopPropagation();
          //           downloadBlocklistCsv();
          //         }}
          //       /> */}
          //       <Button
          //         // color="se"
          //         size="sm"
          //         // outline
          //         onClick={() =>
          //           openCsvPreviewModal(csvDocument?.blockList?.fileUrl)
          //         }
          //       >
          //         <i className="fa fa-eye mr-1 mb-0 text-black" />
          //         View Advertiser Block List
          //       </Button>
          //       <Button
          //         size="sm"
          //         onClick={(e) => {
          //           e.stopPropagation();
          //           downloadBlocklistCsv();
          //         }}
          //       >
          //         <i className="fa fa-download text-info pointer" />
          //       </Button>
          //     </div>
          //   ) : (
          //     "Upload a CSV file containing advertiser domains to block. Admin will sync this to GAM."
          //   )
          // }
          btntext={"Upload Blocklist CSV"}
          onClick={handleFileUpload}
          showuploadIcon={true}
          showDivider={csvDocument?.blockList?.fileUrl ? true : false}
          rightContent={
            <>
              {csvDocument?.blockList?.fileUrl && (
                <>
                  <h5 className="meta-text">
                    File Name :{" "}
                    {getTrimmedFileName(csvDocument?.blockList?.fileUrl)}
                  </h5>
                  <h5 className="meta-text">
                    Last Updated Date :{" "}
                    {csvDocument?.blockList?.createdAt || "-"}
                  </h5>

                  <div className="d-flex align-items-center">
                    <Button
                      // color="se"
                      size="sm"
                      // outline
                      onClick={() =>
                        openCsvPreviewModal(csvDocument?.blockList?.fileUrl)
                      }
                    >
                      <i className="fa fa-eye mr-1 mb-0 text-black" />
                      View Advertiser Block List
                    </Button>
                    <Button
                      size="sm"
                      onClick={(e) => {
                        e.stopPropagation();
                        downloadBlocklistCsv();
                      }}
                    >
                      <i className="fa fa-download text-info pointer" />
                    </Button>
                  </div>
                </>
              )}
            </>
          }
          collapseId="1"
          tableHeading={"Publisher BlockList CSV"}
          tableDescription={"Publisher BlockList All CSV Logs"}
          data={csvData?.AdvertiserBlockListLogs}
        />

        <CardSection
          header={"ads.txt File"}
          btntext={"Download ads.txt"}
          showTextArea={true}
          onClick={downloadADSListCsv}
          showDownloadIcon={true}
          showDivider={csvDocument?.adsDocument?.fileUrl ? true : false}
          rightContent={
            <>
              {csvDocument?.adsDocument?.fileUrl && (
                <>
                  <h5 className="meta-text">
                    File Name :{" "}
                    {getTrimmedFileName(csvDocument?.adsDocument?.fileUrl)}
                  </h5>
                  <h5 className="meta-text">
                    Last Updated Date :{" "}
                    {csvDocument?.adsDocument?.createdAt || "-"}
                  </h5>

                  <div className="d-flex align-items-center">
                    <Button
                      // color="se"
                      size="sm"
                      // outline
                      onClick={() =>
                        openCsvPreviewModal(csvDocument?.adsDocument?.fileUrl)
                      }
                    >
                      <i className="fa fa-eye mr-1 mb-0 text-black" />
                      View Ads.txt
                    </Button>
                    <Button
                      size="sm"
                      onClick={(e) => {
                        e.stopPropagation();
                        downloadADSListCsv();
                      }}
                    >
                      <i className="fa fa-download text-info pointer" />
                    </Button>
                  </div>
                </>
              )}
            </>
          }
          collapseId="2"
          tableHeading={"Publisher Ads.txt files"}
          tableDescription={"Publisher Ads.txt all files logs"}
          data={csvData?.AdsListLogs}
        />
        {/* <CardSection
          header={"Advertiser List File"}
          btntext={"Download Advertiser List"}
          onClick={downloadlistCsv}
          showDownloadIcon={true}
          showDivider={csvDocument?.advertizeDocument?.fileUrl ? true : false}
          rightContent={
            <>
              {csvDocument?.advertizeDocument?.fileUrl && (
                <>
                  <h5 className="meta-text">
                    File Name :{" "}
                    {getTrimmedFileName(
                      csvDocument?.advertizeDocument?.fileUrl,
                    )}
                  </h5>
                  <h5 className="meta-text">
                    Last Updated Date :{" "}
                    {csvDocument?.advertizeDocument?.createdAt || "-"}
                  </h5>

                  <div className="d-flex align-items-center">
                    <Button
                      // color="se"
                      size="sm"
                      // outline
                      onClick={() =>
                        openCsvPreviewModal(
                          csvDocument?.advertizeDocument?.fileUrl,
                        )
                      }
                    >
                      <i className="fa fa-eye mr-1 mb-0 text-black" />
                      View Advertiser List
                    </Button>
                    <Button
                      size="sm"
                      onClick={(e) => {
                        e.stopPropagation();
                        downloadlistCsv();
                      }}
                    >
                      <i className="fa fa-download text-info pointer" />
                    </Button>
                  </div>
                </>
              )}
            </>
          }
          collapseId="3"
          tableHeading={"Publisher Advertiser List"}
          tableDescription={"Publisher Advertiser List files logs"}
          data={csvData?.AdvertiserListLogs}
        /> */}
      </div>
    </>
  );
};

export default Actions;
